import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Button, CircularProgress, Divider, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { ModalAlert } from '../../../components/modal';
import BasicTable from '../../../components/table';
import { TableBar } from '../../../components/table/styles';
import { api, statusApi } from '../../../services/axios';
import { AddModal } from './styles';

import { encode } from 'base-64';
import Modal from "react-modal";
import { ModalAlertDiv } from '../../../components/modal/style';
import ModalDelete from '../../../components/modal/modalDelete';

const Products = () => {
  const url = "core/ajax/products"

  const headers = [
    { label: 'Id', value: 'IdCampProduct' },
    { label: 'Name', value: 'Product' },
    { label: 'Label', value: 'Label' },
    { label: 'CreateDate', value: 'CreateDate' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [showModal, setShowModal] = useState(false)
  const [rows, setRows] = useState({ default: [], filter: [] })
  const [isValidate, setIsValidate] = useState(false)
  const [form, setForm] = useState(defaultForm);

  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [id, setId] = useState();
  const [isCreate, setIsCreate] = useState(true);


  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {
    api.post(url, {
      type: 'list',
      authx: ''
    })
      .then(function (res) {
        setRows({
          default: res.data.map((e) => {
            return {
              ...e,
              IdCampProduct: Number(e.IdCampProduct),
            }
          }), filter: res.data.map((e) => {
            return {
              ...e,
              IdCampProduct: Number(e.IdCampProduct),
            }
          })
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const validation = () => {
    if (form.name === '' || form.label === '') {
      setIsValidate(true)
      return false
    } else {
      return true
    }
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      // height: "90%",
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',

    }
  };


  const updateForm = (row) => {
    setForm({
      name: row.Product,
      label: row.Label,
    })
    setIsCreate(false)
    setShowModal(true)
    setId(row.IdCampProduct)
  }

  const confirmUpdateForm = () => {
    api.post(url, {
      type: 'update',
      IdCampProduct: id,
      Product: form.name,
      Label: form.label,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const create = () => {
    statusApi.get("status").then(function (res) {
      const arr = res.data.split("|")
      api.post(url, {
        Product: form.name,
        Label: form.label,
        type: 'insert',
        authx: ''
      })
        .then(function (res) {
          res.data === 'problems.' && window.location.reload(false)
          setAlert(res.data)
          listUpdate()
        })
        .catch(function (error) {
          console.log(error);
        })
    }).catch(function (error) {
      console.log(error);
    });
  }

  const onDelete = (id) => {
    setId(id)
    setShowDelete(!showDelete)
    setAlert({ status: "go" })
  }

  const confirmDelete = () => {
    api.post(url, {
      type: 'delete',
      IdCampProduct: id,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const handleActive = (id, active) => {
    const url = "core/ajax/engines"

    api.post(url, {
      type: 'activeEngine',
      IdCompany: id,
      Active: active,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.Product.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.Label.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.IdCampProduct.toString().includes(e.target.value) ||
        row.CreateDate.includes(e.target.value)
    });
    setRows({ ...rows, filter })
  }

  return (
    <TableBar>

      <h1>List Products</h1>
      <div className='buttons'>
        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />

        <Button startIcon={<AddIcon />} onClick={() => {
          setShowModal(!showModal)
          setIsCreate(true)
        }} variant="contained">Add</Button>
      </div>
      <BasicTable type={'products'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} onDelete={onDelete} handleActive={handleActive} />
      <Modal isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setIsValidate(false)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <AddModal>
          <h1>Product</h1>

          <Divider className='divider' variant="middle" />
          <TextField margin="dense" label="Name" variant="outlined"
            helperText={form.name === '' && isValidate ? "Incorrect entry." : ""}
            error={form.name === '' && isValidate}
            value={form.name}
            onChange={(e) => {
              setForm({
                ...form,
                name: e.target.value
              })
            }} />
          <TextField margin="dense" label="Label" variant="outlined"
            helperText={form.label === '' && isValidate ? "Incorrect entry." : ""}
            error={form.label === '' && isValidate}
            value={form.label}
            onChange={(e) => {
              setForm({
                ...form,
                label: e.target.value
              })
            }} />
          <Button
            sx={{ marginTop: '1rem' }}
            onClick={() => {
              if (validation()) {
                isCreate ? create() : confirmUpdateForm()
                setShowAlert(!showAlert)
              } else {
                console.log(form);
              }
            }} variant="contained">{isCreate ? 'Create' : 'Update'}</Button>
        </AddModal>
      </Modal>

      {/* Modal de Alerta */}
      <ModalAlert showModal={showAlert} onClose={() => {
        setShowAlert(!showAlert)
        setAlert({ msg: '', status: undefined })
      }} onClickOutside={false}>
        {alert.status === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Creating generator...</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : alert.status === 'ok' ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h1>{alert.msg}</h1>
              <h3>:&#40;	</h3>
              <h3>{alert.msg}</h3>

            </ModalAlertDiv>}
      </ModalAlert>

      {/* Modal de delete */}
      <ModalDelete type={'product'} showDelete={showDelete} alert={alert} setShowDelete={setShowDelete} setAlert={setAlert} confirmDelete={confirmDelete} />
    </TableBar >
  );
}

export default Products;


const defaultForm = {
  name: '',
  label: '',
}